import { Color, LeaseCarDataService, Option, Upgrade } from 'types';

export const SET_OPTIONS_AND_ACCESSOIRES = 'CHOSEN_LEASE_CAR/SET_OPTIONS_AND_ACCESSOIRES';
export const SET_UPGRADE = 'CHOSEN_LEASE_CAR/SET_UPGRADE';
export const SET_SERVICES = 'CHOSEN_LEASE_CAR/SET_SERVICES';
export const SET_DURATION = 'CHOSEN_LEASE_CAR/SET_DURATION';
export const SET_KILOMETRAGE = 'CHOSEN_LEASE_CAR/SET_KILOMETRAGE';
export const SET_PRICE_POINT_ID = 'CHOSEN_LEASE_CAR/SET_PRICE_POINT_ID';
export const SET_PRICE_POINT_PRICE = 'CHOSEN_LEASE_CAR/SET_PRICE_POINT_PRICE';
export const SET_COLOR = 'CHOSEN_LEASE_CAR/SET_COLOR';
export const RESET_CHOSENLEASECAR = 'CHOSEN_LEASE_CAR/RESET_CHOSENLEASECAR';
export const SET_TOTAL_PRICE = 'CHOSEN_LEASE_CAR/SET_TOTAL_PRICE';
export const SET_CHECKOUT_BEGINS = 'SET_CHECKOUT_BEGINS';
export const SET_PAYMENT_IN_ADVANCE_CHOICE = 'SET_PAYMENT_IN_ADVANCE_CHOICE';
export const SET_PAYMENT_IN_ADVANCE_AMOUNT = 'SET_PAYMENT_IN_ADVANCE_VALUE';

export type SetCheckoutBeginsAction = {
	type: typeof SET_CHECKOUT_BEGINS;
	payload: boolean;
};

export type SetOptionsAndAccessoiresAction = {
	type: typeof SET_OPTIONS_AND_ACCESSOIRES;
	payload: Option[];
};

export type SetServices = {
	type: typeof SET_SERVICES;
	payload: LeaseCarDataService[];
};

export type SetUpgrade = {
	type: typeof SET_UPGRADE;
	payload: Upgrade;
};

export type SetDuration = {
	type: typeof SET_DURATION;
	payload: string;
};

export type SetKilometrage = {
	type: typeof SET_KILOMETRAGE;
	payload: string;
};

export type SetPricePointId = {
	type: typeof SET_PRICE_POINT_ID;
	payload: number;
};

export type SetPricePointPrice = {
	type: typeof SET_PRICE_POINT_PRICE;
	payload: number;
};

export type SetTotalPrice = {
	type: typeof SET_TOTAL_PRICE;
	payload: number;
};

export type SetChosenLeaseCarColor = {
	type: typeof SET_COLOR;
	payload: Color;
};

export type SetPaymentInAdvanceChoice = {
	type: typeof SET_PAYMENT_IN_ADVANCE_CHOICE;
	payload: boolean;
};

export type SetPaymentInAdvanceAmount = {
	type: typeof SET_PAYMENT_IN_ADVANCE_AMOUNT;
	payload: number | undefined;
};

export type ResetChosenLeaseCar = {
	type: typeof RESET_CHOSENLEASECAR;
};

export type ChosenLeaseCarActionTypes =
	| SetOptionsAndAccessoiresAction
	| SetServices
	| SetUpgrade
	| SetDuration
	| SetKilometrage
	| SetPricePointId
	| SetPricePointPrice
	| SetChosenLeaseCarColor
	| SetTotalPrice
	| SetPaymentInAdvanceChoice
	| SetPaymentInAdvanceAmount
	| ResetChosenLeaseCar
	| SetCheckoutBeginsAction;
